import React from 'react';
import { MarkerLabel } from 'types/markerTypesV2/m-v2-general.js';
import { PW_MARKER_SELECTOR } from 'utilities/consts/variable-types';

export const PillLabelV2 = ({
  labelText,
  labelTextHover,
  children,
}: {
  labelText?: MarkerLabel['text'];
  labelTextHover?: MarkerLabel['textHover'];
  children: React.ReactNode;
}): JSX.Element => {
  /**
   * We need to set the anchor point iconAnchor
   * For text shadow apply text-shadow-black
   *  */
  return (
    <div data-module="pill-label-v2" className="Pill pill--padding pill--border border-pill-label">
      <div
        className={`bg-transparent u-text-sm u-textBold u-textNoWrap u-pT-xxs u-pB-xxs u-pL-ssm 
          u-pR-ssm u-flex u-flexAlignItemsCenter u-textWhite 
          ${labelTextHover ? 'pill-v2--has-hover-text' : ''}`}
        // add shadow to text to avoid it blending into the background
        style={{ textShadow: '0 0 5px black' }}
        data-testid={PW_MARKER_SELECTOR}
      >
        <span className="pill-v2--text u-flex-1">{labelText}</span>
        {labelTextHover && <span className="pill-v2--hover-text u-flex-1">{labelTextHover}</span>}
        <div className="u-flex-1">{children}</div>
      </div>
    </div>
  );
};
